import Talents from './Talents'
import TalentSearch from './TalentSearch'

export default function install(Vue) {
  Vue.component(Talents.name, Talents)
  Vue.component(TalentSearch.name, TalentSearch)
}
